@if (isAdmin) {
  <div class="tabs-wrapper">
    <app-tabs
      [tabHeaders]="tabs"
      [(selectedTab)]="selectedTab"
      (selectedTabChange)="onTabChange($event)"
      type="pill"
      size="medium"
      [fitContent]="true"
    ></app-tabs>
  </div>
}

<div class="orders-content">
  @if (!isLoading && !loadError && data.length === 0 && !hasActiveFilters) {
    <div class="empty-state">
      <div class="empty-state-icon">
        <lucide-icon name="ShoppingCart" [size]="40"></lucide-icon>
      </div>
      <h3 class="empty-state-title">{{ 'orders.empty.title' | transloco }}</h3>
      <p class="empty-state-text">{{ 'orders.empty.subtitle' | transloco }}</p>
      <app-button
        [label]="'orders.empty.firstOrder' | transloco"
        icon="Plus"
        (onClick)="onCreateOrder()"
      ></app-button>
    </div>
  } @else {
    <app-table
      [data]="data"
      [columns]="headers"
      [mainField]="mainField"
      [title]="'orders.table.title' | transloco"
      [rows]="limit"
      [totalRecords]="totalRecords"
      [isLoading]="isLoading"
      [loadError]="loadError"
      (retryLoad)="loadOrders()"
      mobileSubtitleField="mobileSummary"
      (onPageChange)="onPageChange($event)"
      (onSort)="onSort($event)"
      [hideCheckboxes]="true"
      [showActionButton]="true"
      [actionButtonLabel]="'orders.table.newOrder' | transloco"
      (actionButtonClick)="onCreateOrder()"
      [pillFilters]="pillFilters"
      [pillFilterValues]="currentFilters"
      (inlineFilterChange)="onInlineFilterChange($event)"
      [showSearch]="!isClient"
      (searchEvent)="onInlineFilterChange({ key: 'userName', value: $event })"
      [showNavigationButton]="true"
      navigationButtonIcon="MoveRight"
      (navigationTriggered)="openOrder($event)"
      (rowSelected)="openOrder($event)"
    ></app-table>
  }
</div>
